<template>
    <div>
        <iframe
            ref="iframe"
            :src="src"
            :title="title"
            width="100%"
            style="border:none;"
        />
    </div>
</template>

<script>
export default {
    props: {
        src: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        }
    },
    mounted() {
        // @see AppIframe.md for details on iframe height adjustment
        const iframe = this.$refs.iframe;

        window.addEventListener('message', (event) => {
            if (event.data?.type === 'iframeHeight') {
                const { newHeight, delta } = event.data;
                const iframeTop = iframe.offsetTop;
                const oldBottom = iframeTop + iframe.offsetHeight;

                const scrollY = window.scrollY;
                const viewportBottom = scrollY + window.innerHeight;

                // 5px buffer
                iframe.style.height = newHeight + 5 + 'px';

                if (viewportBottom > oldBottom) {
                    window.scrollTo({ top: scrollY + delta, behavior: 'instant' });
                }
            }
        });
    }
};
</script>
